import * as React from "react";
import { Input, Checkbox } from "@progress/kendo-react-inputs";
import EditForm from "../../../components/Setting/EditForm";
import ColorPicker from "components/common/ColorPicker/ColorPicker";

const EditActivity = (props) => {
  return (
    <EditForm
      type={props.type}
      item={props.item}
      onSubmit={props.onSubmit}
      cancelEdit={props.cancelEdit}
      fields={[
        {
          name: "name",
          component: Input,
          label: "Name",
          validationMessage: "Name is required",
        },
        {
          name: "code",
          component: Input,
          label: "Code",
          validationMessage: "Code is required",
        },
        {
          name: "rowStyle",
          component: ColorPicker,
          label: "Row colour",
        },
        {
          name: "active",
          component: Checkbox,
          label: "Active",
          defaultChecked: true,
          type: "checkbox",
        },
        {
          name: "allowTime",
          component: Checkbox,
          label: "Time",
          type: "checkbox",
        },
        {
          name: "allowDocument",
          component: Checkbox,
          label: "Documents",
          type: "checkbox",
        },
      ]}
      formId="activity-form"
      title="Activity Type"
    />
  );
};

export default EditActivity;
